import { render, staticRenderFns } from "./UserMng.vue?vue&type=template&id=180030e0&scoped=true"
import script from "./UserMng.vue?vue&type=script&lang=js"
export * from "./UserMng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180030e0",
  null
  
)

export default component.exports